<script>
import Content from '@/services/Content'
import validationMessages from '@/components/validations'
import { required } from "vuelidate/lib/validators";
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    validationMessages, ckeditor: CKEditor.component, flatPickr,
  },
  data() {
    return {
      csrf_token: localStorage.getItem('csrf_token'),
      showModal: false,
      tryingToSubmit: false,
      submitted: false,
      title: "",
      content: "",
      image: "",
      link: "",
      published: "",
      date: '',
      time: '',
      file: null,
      acceptedFileTypeErrorMessage:'',
      acceptedFileTypeError:false,
      acceptedFileSizeErrorMessage:'',
      acceptedFileSizeError:false,
      content_type: "",
      image_removed: false,
      editor: ClassicEditor,
      editorData: '',
      dateconfig: {
        enableTime: false,
        dateFormat: "Y-m-d", 
        minDate: new Date(), 
      },
      timeconfig: {
        enableTime: true,
        noCalendar: true,
        time_24hr: true,
        minuteIncrement: 1,
        dateFormat: "H:i",
      },
      verified_checked: true,
      editorConfig: {
        toolbar: [
          'heading',
          '|',
          'bold', 'italic',
          'link',
          '|',
          'bulletedList', 'numberedList',
          'blockQuote',
          '|',
          'undo', 'redo'
        ]
      },
      accepted_file_types: ['image/jpeg', 'image/png','image/gif','image/webp','image/bmp'],
      accepted_file_size:4096,
      isDragOver: false,

    };
  },
  validations: {
    title: {required},
    content: {required},
    published: {required},
  },
  watch: {
    date(newDate) {
      this.updatePublished();
    },
    time(newTime) {
      this.updatePublished();
    }
  },
  methods: {
    refreshEditorialsData() {
      this.$emit('refreshScreen') //event from parent
    },

    addEditorial() {
      if(this.acceptedFileTypeError || this.acceptedFileSizeError) return;

      this.tryingToSubmit = true;
      this.submitted = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.tryingToSubmit = false;
        return;
      }

      const formData = new FormData();
      formData.append("title", this.title);
      formData.append("content", this.content);
      formData.append("image", this.file);
      formData.append("published", this.published);
      formData.append("csrf_token", this.csrf_token);
      formData.append("content_type", this.content_type);
      formData.append("active", this.verified_checked == true ? 1 : 0);

      Content.addEditorials(formData)
          .then(() => {
            this.successmsg("Editorial Created!");
            this.closeModal();
            this.refreshEditorialsData();
          })
          .catch((error) => {
            const errorMsg = error.response?.data?.error || "Failed to create editorial";
            this.failedmsg(errorMsg);
          })
          .finally(() => {
            this.tryingToSubmit = false;
          });
    },
    closeModal() {
      this.showModal = false;
    },
    openDatePicker() {
      this.$refs.datePicker.$el.click();
    },
    openTimePicker() {
      this.$refs.timePicker.$el.click();
    },
    updatePublished() {
      if (this.date && this.time) {
        this.published = `${this.date} ${this.time}`;
      } else if (this.date) {
        this.published = this.date;
      } else {
        this.published = '';
      }
    },
    triggerFileInput() {
      this.$refs['file-input'].click();
    },
    handleFileDrop(event) {
      this.isDragOver = false;
      const files = event.dataTransfer && event.dataTransfer.files;
      if (files && files.length > 0) {
        const file = files[0];
        // Create a synthetic event object to reuse selectFile logic
        const syntheticEvent = {
          target: {
            files: [file]
          }
        };
        this.selectFile(syntheticEvent);
      }
    },
    selectFile(event) {
      if (this.image) {
        URL.revokeObjectURL(this.image);
      }
      const file = event.target.files[0];
      //console.log(file)
      let bytes = file.size;
      let sizeInKB = bytes / 1024;
      const formatedKB = sizeInKB.toFixed(2);

      //console.log(formatedKB)
      if (formatedKB > this.accepted_file_size) {
        this.acceptedFileSizeErrorMessage = 'File size too large | Maximum allowed size is ' + this.accepted_file_size + ' KB';
        this.acceptedFileSizeError = true;

      }else{
        this.acceptedFileSizeErrorMessage = '';
        this.acceptedFileSizeError = false;
      }
      if(!this.accepted_file_types.includes(file.type)) {
        this.acceptedFileTypeErrorMessage = 'File not accepted | Accepted formats are png, jpg, gif, bmp, webp';
        this.acceptedFileTypeError = true;
      }else{
        this.acceptedFileTypeErrorMessage = '';
        this.acceptedFileTypeError = false;
      }
      this.file = file;
      this.image = URL.createObjectURL(file);
    },
    removeImage() {
      this.file = null;
      if (this.image) {
        URL.revokeObjectURL(this.image);
      }
      this.image = "";
      if (this.$refs['file-input']) {
        this.$refs['file-input'].value = '';
      }
      this.image_removed = true;
    },

    resetProps() {
      this.submitted = false;
      this.title = '';
      this.content = '';
      if (this.image) URL.revokeObjectURL(this.image);
      this.image = '';
      this.file = null;
      this.published = '';
      this.date = '';
      this.time = '';
      this.verified_checked = true;
      this.isDragOver = false;
    },
  }
};
</script>

<template>
  <b-modal id="add_editorials" size="lg" v-model="showModal" @hidden="resetProps" title-class="font-18" no-enforce-focus>
    <template v-slot:modal-header>
      <div class="w-100">
        <h5 class="modal-title mb-0">Create Editorial</h5>
        <p class="text-muted mb-0 mt-2">Add a new editorial article to your news feed</p>
      </div>
      <button type="button" class="btn-close" @click="closeModal" aria-label="Close"></button>
    </template>
    <form @submit.prevent="addEditorial">
        <div class="card mb-3">
          <div class="card-body py-2">
            <h4 class="card-title mb-1">Basic Information</h4>
            <p class="text-muted mb-3">Essential details about your editorial</p>
            <div class="mb-2">
              <label class="mb-1">Title *</label>
              <b-form-input v-model="title" placeholder="e.g., Industry Insights: The Future of Technology"></b-form-input>
            </div>
            <validationMessages 
                  v-if="submitted"
                  :fieldName="'Title'"
                  :validationName="$v.title">
            </validationMessages>
            <div class="row mb-2">
              <div class="col-md-4">
                <label class="mb-1">
                  <i class="uil uil-calendar-alt me-1"></i>Date *
                </label>
                <div class="position-relative">
                  <flat-pickr
                    ref="datePicker"
                    v-model="date"
                    :config="dateconfig"
                    class="form-control pe-4"
                    name="date"
                  />
                  <i class="uil uil-calendar-alt position-absolute top-50 end-0 translate-middle-y me-2 text-muted" 
                     style="cursor: pointer; pointer-events: all;"
                     @click="openDatePicker"></i>
                </div>
              </div>
              <div class="col-md-4">
                <label class="mb-1">
                  <i class="uil uil-clock me-1"></i>Time *
                </label>
                <div class="position-relative">
                  <flat-pickr
                    ref="timePicker"
                    v-model="time"
                    :config="timeconfig"
                    class="form-control pe-4"
                    name="time"
                  />
                  <i class="uil uil-clock position-absolute top-50 end-0 translate-middle-y me-2 text-muted" 
                     style="cursor: pointer; pointer-events: all;"
                     @click="openTimePicker"></i>
                </div>
              </div>
              <div class="col-md-4">
                <label class="mb-1">
                  <i class="uil uil-check-circle me-1"></i>Status
                </label>
                <div class="form-check form-switch form-switch-lg">
                  <label class="form-check-label" for="editorialStatus">Active</label>
                  <input v-model="verified_checked"
                         type="checkbox"
                         class="form-check-input"
                         id="editorialStatus"
                  />
                </div>
              </div>
            </div>
            <validationMessages
              v-if="submitted"
              :fieldName="'Published'"
              :validationName="$v.published"
            ></validationMessages>
          </div>
        </div>
        <div class="card mb-3">
          <div class="card-body py-2">
            <h4 class="card-title mb-1">
              <i class="uil uil-image me-2"></i>Header Image
            </h4>
            <p class="text-muted mb-3">Upload a banner image for the editorial (recommended: 1200x400px)</p>
            <b-form-group label-for="image" class="mb-3">
              <!-- Image Preview -->
              <div v-if="image" class="mb-3">
                <div class="image-preview-container position-relative" style="width: 100%; min-height: 200px; background: #f8f9fa; border-radius: 8px; overflow: hidden;">
                  <img :src="image" alt="Preview" style="width: 100%; height: 100%; object-fit: cover;">
                  
                  <!-- Text Overlay (Bottom Left) -->
                  <div class="position-absolute" style="bottom: 15px; left: 15px; background: rgba(0,0,0,0.6); color: white; padding: 8px 12px; border-radius: 4px;">
                    <div style="font-size: 14px; font-weight: 600; margin-bottom: 2px;">Header Image Preview</div>
                    <div style="font-size: 12px; opacity: 0.9;">This is how your image will appear</div>
                  </div>
                  
                  <!-- Remove Button (Bottom Right) -->
                  <button 
                    type="button" 
                    @click="removeImage" 
                    class="btn btn-sm position-absolute"
                    style="bottom: 15px; right: 15px; background: rgba(255,255,255,0.95); border: 1px solid #dee2e6; color: #495057; font-size: 12px; padding: 4px 12px; display: flex; align-items: center;"
                  >
                    <i class="uil uil-times me-1"></i>Remove
                  </button>
                </div>
                <p v-if="acceptedFileTypeError" class="text-danger mt-2 mb-0">{{acceptedFileTypeErrorMessage}}</p>
                <p v-if="acceptedFileSizeError" class="text-danger mt-2 mb-0">{{acceptedFileSizeErrorMessage}}</p>
              </div>
              
              <!-- Upload Area -->
              <div 
                v-if="!image"
                class="upload-area text-center position-relative"
                :class="{'border-primary': isDragOver}"
                @dragover.prevent="isDragOver = true"
                @dragleave.prevent="isDragOver = false"
                @drop.prevent="handleFileDrop"
                style="
                  cursor: pointer;
                  min-height: 220px;
                  display: flex; flex-direction: column; justify-content: center; align-items: center;
                  border: 2px dashed #cbd5e1;
                  border-radius: 12px;
                  padding: 28px;
                  background: #fff;
                "
                @click="triggerFileInput"
              >
                <div style="
                  width: 72px; height: 72px; border-radius: 9999px;
                  background: #eef2ff; display: flex; align-items: center; justify-content: center;
                  margin-bottom: 12px;
                ">
                  <i class="uil uil-upload" style="font-size: 28px; color: #6b7280;"></i>
                </div>
                <div class="mb-1" style="font-weight: 500; color: #111827;">
                  Drag and drop an image, or click to browse
                </div>
                <div class="text-muted mb-3" style="font-size: 13px;">
                  PNG, JPG, GIF, WEBP, BMP up to 4MB
                </div>
                <button type="button" class="btn btn-light btn-sm" @click.stop="triggerFileInput">
                  <i class="uil uil-upload me-1"></i>
                  Choose File
                </button>
                <input 
                  ref="file-input" 
                  type="file" 
                  @change="selectFile" 
                  accept="image/*" 
                  style="display: none;"
                />
                <p v-if="acceptedFileTypeError" class="text-danger mt-2 mb-0">{{acceptedFileTypeErrorMessage}}</p>
                <p v-if="acceptedFileSizeError" class="text-danger mt-2 mb-0">{{acceptedFileSizeErrorMessage}}</p>
              </div>
            </b-form-group>
          </div>
        </div>

        <div class="card mb-3">
          <div class="card-body py-2">
            <h4 class="card-title mb-1">
              <i class="uil uil-file-alt me-2"></i>Content
            </h4>
            <p class="text-muted mb-3">Write the full editorial content using the rich text editor</p>
            <b-form-group label-for="content" class="mb-3">
              <ckeditor :editor="editor" v-model="content" :config="editorConfig"></ckeditor>
              <validationMessages
                v-if="submitted"
                :fieldName="'Content'"
                :validationName="$v.content">
              </validationMessages>
            </b-form-group>
          </div>
        </div>

        <input type="hidden" name="content_type" v-model="content_type">
        <input type="hidden" name="csrf_token" v-model="csrf_token">
      </form>
        <template v-slot:modal-footer>
            <b-button variant="light" @click="closeModal">Close</b-button>
            <b-button variant="primary" @click="addEditorial" :disabled="tryingToSubmit">
                <b-spinner v-show="tryingToSubmit" small></b-spinner>
                Submit</b-button>
        </template>

    </b-modal>
</template>


<style>
/* Ensure CKEditor popups appear above Bootstrap modal */
.ck.ck-balloon-panel {
  z-index: 10000 !important;
}
</style>